var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6667 4C19.7211 4 17.3333 6.38781 17.3333 9.33333C17.3333 12.2789 19.7211 14.6667 22.6667 14.6667C25.6122 14.6667 28 12.2789 28 9.33333C28 6.38781 25.6122 4 22.6667 4ZM4 22.6667C4 19.7211 6.38781 17.3333 9.33333 17.3333C12.2789 17.3333 14.6667 19.7211 14.6667 22.6667C14.6667 25.6122 12.2789 28 9.33333 28C6.38781 28 4 25.6122 4 22.6667ZM17.3333 18.6667C17.3333 17.9303 17.9303 17.3333 18.6667 17.3333H26.6667C27.403 17.3333 28 17.9303 28 18.6667V25.3333C28 26.8061 26.8061 28 25.3333 28H20C18.5272 28 17.3333 26.8061 17.3333 25.3333V18.6667ZM4 5.33333C4 4.59695 4.59695 4 5.33333 4H13.3333C14.0697 4 14.6667 4.59695 14.6667 5.33333V12C14.6667 13.4728 13.4728 14.6667 12 14.6667H6.66667C5.19391 14.6667 4 13.4728 4 12V5.33333Z",
    fill: "#EC652C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.60e228cbb7666513d298e2397fd23103.svg";
export { ForwardRef as ReactComponent };